
import { z } from "zod";

export const ChargeStrategyEnum = z.enum([
  'days-period-minimum',
  'days-period-upfront',
  'original-charge-for-full-month',
  'original-prorate',
]);

export const UnitOfMeasureEnum = z.enum([
  'multi-family-lite',
  'multi-family',
  'single-family',
]);

export const MFTierSchema = z.object({
  maxUnits: z.number().nullable(),
  unitOfMeasure: UnitOfMeasureEnum,
  pricePerProperty: z.number(),
});

export const SFTierSchema = z.object({
  pricePerUnit: z.number(),
  unitOfMeasure: UnitOfMeasureEnum,
  chargeStrategy: ChargeStrategyEnum,
});

export const TieredUnitCountConfigSchema = z.object({
  MF: z.array(MFTierSchema),
  SF: SFTierSchema,
});

export const PromotedListingsSchema = z.object({
  daysActiveThresholdOverride: z.number().nullable().optional(),
});

export const ActiveFeatureSchema = z.object({
  productKey: z.string(),
});

export const DailyRateSchema = z.enum(['daily-flat', 'monthly-active-days-flat']);

export const CustomConfigSchema = z.object({
  activeFeature: ActiveFeatureSchema.optional(),

  promotedListings: PromotedListingsSchema.optional(),

  tieredUnitCountConfig: TieredUnitCountConfigSchema.optional(),

  dailyRateType: DailyRateSchema.optional(),
});

export type TCustomConfiguration = z.infer<typeof CustomConfigSchema>;
export type TActiveFeatureConfiguration = z.infer<typeof ActiveFeatureSchema>;
export type TPromotedListingsConfiguration = z.infer<typeof PromotedListingsSchema>;
export type TTieredUnitCountConfiguration = z.infer<typeof TieredUnitCountConfigSchema>;
export type TDailyRateConfiguration = z.infer<typeof DailyRateSchema>;
export type TUnitOfMeasure = z.infer<typeof UnitOfMeasureEnum>;
export type TChargeStrategy = z.infer<typeof ChargeStrategyEnum>;
export type TMFTier = z.infer<typeof MFTierSchema>;
export type TSFTier = z.infer<typeof SFTierSchema>;